import { useCallback, useEffect, useState } from "react";
import { getReportingDashboard } from "@/api/analyticsApi";
import { useDateRange } from "@/state/DateRangeContext";

export function useReportingDashboard() {
  const { startDate, endDate } = useDateRange();
  const [data, setData] = useState(/** @type {Record<string, unknown> | null} */ (null));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(/** @type {Error | null} */ (null));

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data: payload } = await getReportingDashboard({ startDate, endDate });
      setData(payload ?? null);
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { data, loading, error, refresh };
}
